import { createFileRoute } from "@tanstack/react-router";

import { Audit } from "./-audit";
import { parseAuditFilters } from "../../../workspaces/label/pages/audit-search";

export const Route = createFileRoute("/_console/label/audit/$episodeId")({
  validateSearch: parseAuditFilters,
  component: AuditedEpisode,
});

/** One episode, open for review. The episode id is unique in the Label door, so this is a
 *  coordinate — the link a reviewer sends when they want a second opinion on one chain. */
function AuditedEpisode() {
  const { episodeId } = Route.useParams();
  return <Audit state={{ ...Route.useSearch(), episode: episodeId }} />;
}
